var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-2-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundaries",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93932168,14.2889746 C7.41636113,14.7324915 6.73942054,15 6,15 C4.34314575,15 3,13.6568542 3,12 C3,10.3431458 4.34314575,9 6,9 C6.73942054,9 7.41636113,9.26750848 7.93932168,9.71102535 L15.0524922,5.56167588 C15.0180311,5.37972946 15,5.19197043 15,5 C15,3.34314575 16.3431458,2 18,2 C19.6568542,2 21,3.34314575 21,5 C21,6.65685425 19.6568542,8 18,8 C17.2605795,8 16.5836389,7.73249152 16.0606783,7.28897465 L8.94750779,11.4383241 C8.98196886,11.6202705 9,11.8080296 9,12 C9,12.1919704 8.98196886,12.3797295 8.94750779,12.5616759 L16.0606783,16.7110254 C16.5836389,16.2675085 17.2605795,16 18,16 C19.6568542,16 21,17.3431458 21,19 C21,20.6568542 19.6568542,22 18,22 C16.3431458,22 15,20.6568542 15,19 C15,18.8080296 15.0180311,18.6202705 15.0524922,18.4383241 L7.93932168,14.2889746 Z",
    id: "Combined-Shape",
    fill: "#BEBEBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.d9435ec8e725f21e0a2fd84ca30807c0.svg";
export { ForwardRef as ReactComponent };